import {SharedModule} from '../../../shared/shared.module';
import {NgModule} from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ModalModule, BsDatepickerModule} from 'ngx-bootstrap';
import {ImageCropperModule} from 'ngx-image-cropper';
import {AssociationLandingComponent} from './association-landing.component';
import {ImageUploadModule} from 'angular2-image-upload';
import {ImgCropperComponent} from './img-cropper/img-cropper.component';
import {ImgPreviewComponent} from './img-preview/img-preview.component';
import {FormsModule} from '@angular/forms';
import { QuillModule } from 'ngx-quill';

@NgModule({
  imports: [
    NgbModule,
    SharedModule,
    ImageCropperModule,
    ImageUploadModule,
    QuillModule.forRoot(),
    ModalModule,
    FormsModule,
    BsDatepickerModule
  ],
  declarations: [AssociationLandingComponent, ImgCropperComponent, ImgPreviewComponent],
  exports: [AssociationLandingComponent],
  entryComponents: [ImgCropperComponent]
})
export class AssociationsLandingModule {}
